import { makeRequest } from 'services/request.service'

export const uploadDocuments = (shipmentId, files) => {
  const form = new FormData()
  for (const file of files) form.append('file', file)
  return makeRequest({ method: 'POST', url: `/shipments/${shipmentId}/documents`, data: form, headers: { 'Content-Type': 'multipart/form-data' } })
}

export const getDocument = (id) => makeRequest({ method: 'GET', url: `/documents/${id}` })
export const updateDocument = (id, data) => makeRequest({ method: 'PUT', url: `/documents/${id}`, data })
export const reextractDocument = (id, docType) =>
  makeRequest({ method: 'POST', url: `/documents/${id}/reextract`, data: docType ? { docType } : {} })
export const deleteDocument = (id) => makeRequest({ method: 'DELETE', url: `/documents/${id}` })

// Fetch the original file as a blob (auth header is applied by the interceptor).
export const fetchDocumentFile = async (id) => {
  const response = await makeRequest({ method: 'GET', url: `/documents/${id}/file`, responseType: 'blob' })
  return response.data
}
